import './color-picker.css';

import React from 'react';

import { Color } from './color';

export type TextColors =
  | 'rgb(255, 0, 0)'
  | 'rgb(255, 165, 0)'
  | 'rgb(255, 255, 0)'
  | 'rgb(0, 128, 0)'
  | 'rgb(0, 128, 128)'
  | 'rgb(173, 216, 230)'
  | 'rgb(0, 0, 255)'
  | 'rgb(128, 0, 128)'
  | 'var(--surface-0)';

const GROUPED_COLORS: TextColors[][] = [
  ['rgb(255, 0, 0)', 'rgb(255, 165, 0)', 'rgb(255, 255, 0)', 'rgb(0, 128, 0)'],
  ['rgb(0, 128, 128)', 'rgb(173, 216, 230)', 'rgb(0, 0, 255)', 'rgb(128, 0, 128)'],
];

interface ColorPickerProps {
  onSelected: (color: TextColors) => void;
  selectedColor?: string | number | boolean;
}

export const ColorPicker = ({ onSelected, selectedColor }: ColorPickerProps) => {
  return (
    <div>
      {GROUPED_COLORS.map((COLOR_GROUP, i) => {
        const isLastRow = i == GROUPED_COLORS.length - 1;

        return (
          <div key={`color-row-${COLOR_GROUP}`} className="flex" style={{ marginBottom: isLastRow ? '' : 3 }}>
            {COLOR_GROUP.map((color, i) => {
              const isLastColumn = i == COLOR_GROUP.length - 1;

              const onClick = () => onSelected(color);

              return (
                <Color
                  key={`color-${color}`}
                  color={color}
                  style={{ marginRight: isLastColumn ? '' : 3 }}
                  onClick={onClick}
                  selected={selectedColor == color}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
